import React from "react";
import { useSelector } from "react-redux";
import { useGetAllOrdersQuery } from "../Apis/orderApi";
import { MainLoader } from "../Components/Page/Common";
import { OrderList } from "../Components/Page/Order";
import { RootState } from "../Storage/Redux/store";

function MyOrders() {
  const userId = useSelector((state: RootState) => state.userAuthStore.id);
  const { data, isLoading } = useGetAllOrdersQuery({ userId });
  return (
    <>
      {isLoading && <MainLoader />}
      {!isLoading && (
        <>
          <div className="d-flex align-items-center justify-content-between mx-5 mt-3">
            <h1 className="text-success d-none d-md-block d-lg-block d-xl-block">My Orders</h1>
            <h1 className="text-success d-block d-md-none d-lg-none d-xl-none mx-auto">My Orders</h1>
          </div>
          <div className="mx-5">
          </div>
          {data?.apiResponse.result.length > 0 && (
            <OrderList
              isLoading={isLoading}
              orderData={data?.apiResponse.result}
            />
          )}
          {!(data?.apiResponse.result.length > 0) && (
            <div className="px-5 py-3">
              You do not have any previous orders.
            </div>
          )}
        </>
      )}
    </>
  );
}

export default MyOrders;